var map = {
	"./avispace/app/header-nav-wrapper/header-navbar-wrapper.component": [
		41181,
		[
			"src_themes_avispace_app_header-nav-wrapper_header-navbar-wrapper_component_ts"
		]
	],
	"./custom/app/header-nav-wrapper/header-navbar-wrapper.component": [
		9600,
		[
			"src_themes_custom_app_header-nav-wrapper_header-navbar-wrapper_component_ts"
		]
	],
	"./dspace/app/header-nav-wrapper/header-navbar-wrapper.component": [
		66515,
		[]
	],
	"./dspace_new/app/header-nav-wrapper/header-navbar-wrapper.component": [
		61820,
		[
			"src_themes_dspace_new_app_header-nav-wrapper_header-navbar-wrapper_component_ts"
		]
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 20991;
module.exports = webpackAsyncContext;